module.exports = __webpack_public_path__ + "static/table-black-186874b274efab2144b77c222d97d5cc.svg";